import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    id: null,
    fecha: null,
    cliente: null,
    prefijo: null,
    detalles: [
        {
            detalleid: null,
            codigo: null,
            precio: null,
            cantidad: null,
            total: null,
            cod_producto: null,
            descripcion: null
        }
    ]
}

const itemSlice = createSlice({
    name: 'item',
    initialState,
    reducers: {
        setDatosGenerales: (state, action) => {
            const { id, fecha, cliente, prefijo } = action.payload;
            state.id = id;
            state.fecha = fecha;
            state.cliente = cliente;
            state.prefijo = prefijo;
        },
        addItem: (state, action) => {
            state.detalles.push(action.payload);
        },
        deleteItem: (state, action) => {
            const detalleid = action.payload;
            state.detalles = state.detalles.filter(item => item.detalleid !== detalleid);
        },
        clearItems: (state) => {
            state.detalles = [];
        },
        clearFactura: (state, action) => {
            const id = action.payload;
            state.item = state.item.filter(x => x.id !== id);
        }
    }
})

export const { setDatosGenerales, addItem, deleteItem, clearItems, clearFactura } = itemSlice.actions;
export default itemSlice.reducer;